import {
    ContentDataDefinitionLoader,
    createRegisterableComponentWithData,
    isPublicationCardItem,
} from '@news-mono/web-common'
import React from 'react'
import { RelatedContent } from './RelatedContent'

export interface RelatedContentRegistrationProps {
    sectionHeaderAs?: React.ElementType
    title?: string
    displayMode?: 'list' | 'juliet'
    numberOfItems?: number
    itemHeaderAs?: React.ElementType
}

export const RelatedContentRegistration = createRegisterableComponentWithData(
    'related-content',
    ContentDataDefinitionLoader,
    (
        {
            title,
            displayMode,
            numberOfItems,
            sectionHeaderAs,
            itemHeaderAs,
        }: RelatedContentRegistrationProps,
        data,
        services,
    ) => {
        if (data.loaded) {
            const publications = data.result.publications.filter(
                isPublicationCardItem,
            )

            if (publications.length) {
                return (
                    <RelatedContent
                        items={publications}
                        title={title}
                        onEvent={services.onEvent}
                        displayMode={displayMode}
                        numberOfItems={numberOfItems}
                        sectionHeaderAs={sectionHeaderAs}
                        itemHeaderAs={itemHeaderAs}
                    />
                )
            }
        }

        return null
    },
)
